<template>
  <div></div>
</template>

<script>
export default {
  name: "Logout",
  mounted() {
    localStorage.removeItem("jwt");
    this.$router.replace({ name: "UserLogin" });
  },
};
</script>
